import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { smsSubscriptionDataSource } from 'infrastructure/data-sources/subscriptions';
import { SmsSubscription } from 'infrastructure/enums';

import { PopoverLabel } from './popover-label';

import type { ISmsSubscriptionItem } from 'infrastructure/data-sources/subscriptions';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  ISmsSubscriptionItem['id'],
  ISmsSubscriptionItem
>[];

const DISABLED_OPTIONS = [
  SmsSubscription.TwilioDisabled,
  SmsSubscription.TwilioEnabled,
];

interface ISmsSubscriptionsSelectBoxProps
  extends Omit<IBaseSelectBoxProps<SmsSubscription>, 'options'> {}

const SmsSubscriptionsSelectBox: React.FC<ISmsSubscriptionsSelectBoxProps> = (
  props,
) => {
  const dataSource = useMemo(() => smsSubscriptionDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => {
        let originalElLabel: React.ReactNode = el.name;
        let disabled = el.id ? DISABLED_OPTIONS.includes(el.id) : false;
        const isDisabledByTwilio =
          props?.value === SmsSubscription.TwilioDisabled;

        if (isDisabledByTwilio) {
          if (el.id === SmsSubscription.TwilioDisabled) {
            originalElLabel = <PopoverLabel label={originalElLabel} />;
          }

          disabled = true;
        }

        return {
          value: el.id,
          label: originalElLabel,
          disabled,
          record: el,
        };
      }),
    [dataSource, props?.value],
  );

  return (
    <BaseSelectBox
      options={options}
      {...props}
      open={props?.readonly ? false : undefined}
    />
  );
};

export default SmsSubscriptionsSelectBox;
